module.exports = __webpack_public_path__ + "media/images/trix_color-e3ac54aa610fc42f315a931bd1b7ea96.svg";